import { Seo } from '@/components/Seo';
import { JsonLd, makeBreadcrumbSchema } from '@/components/Schema';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function HowItWorks() {
  return (
    <>
      <Seo
        title="How It Works | Free Online Resume Builder"
        description="Create a professional resume in 3 easy steps. No sign-up, no hidden fees, instant PDF download."
        path="/how-it-works"
      />
      <JsonLd schema={makeBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'How It Works', path: '/how-it-works' }])} />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-[800px] px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-[#00D4AA] hover:text-[#00B894]">
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <h1 className="mt-6 text-3xl font-bold text-[#0A2540] md:text-4xl">How It Works</h1>
          <p className="mt-4 text-lg text-[#4A5568]">
            Build a professional, ATS-friendly resume in 3 simple steps. No account needed.
          </p>

          <div className="mt-12 space-y-10">
            {[
              {
                step: 1,
                title: 'Choose a Template',
                desc: 'Browse our collection of ATS-friendly resume templates. Pick one that matches your experience level and industry.',
              },
              {
                step: 2,
                title: 'Fill in Your Details',
                desc: 'Add your work experience, education, skills, and a professional summary. Our editor is simple and fast.',
              },
              {
                step: 3,
                title: 'Download Your PDF',
                desc: 'Preview your resume and download it as a polished PDF. No paywall, no hidden fees.',
              },
            ].map((s) => (
              <div key={s.step} className="flex gap-6">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#00D4AA] text-base font-bold text-[#0A2540]">
                  {s.step}
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-[#0A2540]">{s.title}</h2>
                  <p className="mt-2 text-[#4A5568]">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/app/create"
              className="btn-primary inline-flex items-center justify-center rounded-[10px] px-8 py-4 text-base font-semibold"
            >
              Create My Free Resume
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default HowItWorks;
